import { render, staticRenderFns } from "./Leaders.vue?vue&type=template&id=34b49541&scoped=true"
import script from "./Leaders.vue?vue&type=script&lang=js"
export * from "./Leaders.vue?vue&type=script&lang=js"
import style0 from "./Leaders.vue?vue&type=style&index=0&id=34b49541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b49541",
  null
  
)

export default component.exports